import useScrolledPast from '../libs/utils/useScrolledPast'

const StickyNavbar = ({children, className, ...props}) => {

  const sticky = useScrolledPast(20)

  return (
    <header
      {...props}
      className={`${className ? className : ''}${sticky ? ' navbar-stuck': ''}`}
    >{children}</header>
  )
}

export default StickyNavbar
